import React, { useEffect, useState } from 'react';
import { S } from '../users/Users.style';
import { Input } from '../../components/Input';
import { useAuth } from '../../traits/hooks/useAuth';
import { useGetClient } from '../../traits/api/client/useClient';
import { useUpdateClientMe } from '../../traits/api/client/useUpdateClientMe';

export const ClientSettings = () => {
  const { isCustomerAdmin } = useAuth();
  const { data: client, isLoading } = useGetClient();
  const updateClient = useUpdateClientMe();

  const [name, setName] = useState('');
  const [policyLink, setPolicyLink] = useState('');

  useEffect(() => {
    if (!client) return;
    setName(client.name ?? '');
    setPolicyLink(client.policyLink ?? '');
  }, [client]);

  if (!isCustomerAdmin) {
    return <S.H6>Du har inte behörighet att se denna sida</S.H6>;
  }

  if (isLoading || !client) {
    return <div>Loading...</div>;
  }

  const onSave = (ev: React.FormEvent) => {
    ev.preventDefault();
    updateClient.mutate({
      name: name.trim(),
      policyLink: policyLink.trim() || undefined,
    });
  };

  return (
    <>
      <S.HeaderContainer>
        <S.H3>Organisationsinställningar</S.H3>
      </S.HeaderContainer>
      <S.Form onSubmit={onSave}>
        <S.FormRow>
          <Input
            value={name}
            onChange={(ev) => setName(ev.target.value)}
            type="text"
            placeholder="Organisationsnamn"
            label="Namn"
          />
        </S.FormRow>
        <S.FormRow>
          <Input
            value={policyLink}
            onChange={(ev) => setPolicyLink(ev.target.value)}
            type="text"
            placeholder="https://..."
            label="Policy-länk"
          />
        </S.FormRow>
        <S.FormRow>
          <S.Button type="submit">Spara</S.Button>
        </S.FormRow>
      </S.Form>
    </>
  );
};
